import { z } from "zod";
import { ruoloSchema } from "./common.js";
export const utenteAmministratoSchema = z.object({
    id: z.string().uuid(),
    username: z.string().max(64),
    email: z.string().email().nullable(),
    nome: z.string().max(120),
    cognome: z.string().max(120),
    ruolo: ruoloSchema,
    gestore_id: z.string().uuid().nullable(),
    attivo: z.boolean(),
    mfa_enabled: z.boolean(),
    last_login_at: z.string().datetime().nullable(),
    created_at: z.string().datetime(),
});
export const createUtenteSchema = z.object({
    username: z.string().min(3).max(64),
    email: z.string().email().optional(),
    nome: z.string().min(1).max(120),
    cognome: z.string().min(1).max(120),
    ruolo: ruoloSchema,
    gestore_id: z.string().uuid().optional(),
    password: z.string().min(12).max(128),
});
export const updateUtenteSchema = z.object({
    email: z.string().email().optional(),
    nome: z.string().min(1).max(120).optional(),
    cognome: z.string().min(1).max(120).optional(),
    ruolo: ruoloSchema.optional(),
    gestore_id: z.string().uuid().nullable().optional(),
    attivo: z.boolean().optional(),
});
export const resetPasswordAdminResponseSchema = z.object({
    temporary_password: z.string(),
});
//# sourceMappingURL=admin.js.map